<div class="edit-team-content">
  <div>
    <div class="edit-team-header">
      <div>Teaminformation</div>
      <div
        style="display: flex; flex-direction: row; justify-content: flex-end"
      >
        <div style="margin-right: 24px">
          <button mat-icon-button (click)="clickSave()">
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <div style="margin-right: 24px">
          <button mat-icon-button (click)="clickCancel()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div style="flex: 1; overflow-y: hidden">
    <div style="height: 100%; width: 100%; max-width: 100%; overflow-y: auto">
      <div style="padding: 16px">
        <div>
          <mat-checkbox
            [checked]="data.inactive"
            (change)="onActiveChange($event)"
          >
            Deaktiviert
          </mat-checkbox>
        </div>

        <div class="input-row">
          <div style="flex: 1">
            <div style="width: 60px">
              <app-input
                label="Nr."
                #nr
                [required]="true"
                [(value)]="data.team_number"
                name="team_number"
              ></app-input>
            </div>
          </div>
          <div style="flex: 1; margin-left: 2rem">
            <app-input
              label="Benutzername"
              #username
              [required]="true"
              [(value)]="data.username"
              name="username"
              [maxlength]="userNameLength"
            ></app-input>
          </div>
        </div>
        <!---->
        <div class="input-row">
          <div style="flex: 1">
            <app-input
              #fname
              label="Vorname"
              [required]="true"
              [(value)]="data.first_name"
              (afterValueChange)="onNameChange()"
              name="firstname"
              [maxlength]="firstNameLength"
            ></app-input>
          </div>
          <div style="flex: 1; margin-left: 2rem">
            <app-input
              label="Nachname"
              #lname
              [required]="true"
              [(value)]="data.last_name"
              (afterValueChange)="onNameChange()"
              name="lastname"
              [maxlength]="lastNameLength"
            ></app-input>
          </div>
        </div>
        <!---->
        <div class="input-row">
          <div style="flex: 1">
            <app-input
              label="Telefon (Mobil)"
              [(value)]="data.mobile"
              name="mobile"
              [maxlength]="phoneLength"
            ></app-input>
          </div>
          <div style="flex: 1; margin-left: 2rem">
            <app-input
              label="E-Mail"
              #email
              type="email"
              [required]="true"
              [(value)]="data.email"
              name="email"
              [maxlength]="emailLength"
            ></app-input>
          </div>
        </div>
        <div *ngIf="id > 0">
          <button mat-flat-button (click)="newPassword()"
          class="light-bg-color full-size-button">
            <mat-icon>mail</mat-icon>
            Neues Passwort erzeugen und verschicken
          </button>
        </div>
        <div
          *ngIf="!(id > 0)"
          class="light-font-color"
          style="margin-top: 16px"
        >
          Das Password wird nach dem Erstellen automatisch verschickt.
        </div>
      </div>
    </div>
  </div>
</div>
